<template>
  <div>
    <div class="card z-depth-5 mb-4">
      <h6 class="text-center font-weight-bold py-3">Messages</h6>
    </div>
    <div class="row">
      <div
        class="col-md-6 mb-4"
        v-for="(conversation, index) in conversations"
        :key="index"
      >
        <div class="card z-depth-5 p-3 bg-light morpheus-den-gradient">
          <h6 class="font-weight-bold py-3">
            <small>
              <span class="badge badge-success p-2 mr-2"
                ><i class="fas fa-user"></i>
                {{
                  conversation.receiver.first_name + " " + conversation.receiver.last_name
                }}
              </span>
              <span class="badge badge-dark p-2">
                {{ conversation.last_message.date | moment("dddd, MMMM Do YYYY") }}
              </span>
            </small>
          </h6>
          <p class="white-text">
            <i class="fas fa-comments"></i> {{ conversation.last_message.message }}
          </p>
          <span class="d-none">{{ (receiverId = conversation.receiver._id) }}</span>
          <span class="d-none">{{ (conversationId = conversation._id) }}</span>

          <div>
            <button @click="getMessages(conversation._id)" class="btn btn-dark btn-sm">
              view conversation
            </button>
            <form @submit.prevent="sendNewMessage">
              <mdb-container>
                <!-- trigger modal button -->

                <!-- cookie modal -->
                <mdb-modal :show="modalChat" scrollable removeBackdrop centered>
                  <mdb-modal-body class="morpheus-den-gradient white-text">
                    <div>
                      <button
                        type="button"
                        class="btn btn-danger btn-sm btn-block"
                        data-dismiss="modal"
                        @click="modalChat = false"
                      >
                        Close chat
                      </button>
                    </div>
                    <div class="shadow border z-depth-3 p-3">
                      <h6 class="font-weight-bold">
                        Converation with:
                        {{
                          conversation.receiver.first_name +
                          " " +
                          conversation.receiver.last_name
                        }}
                      </h6>
                      <hr class="bg-light" />
                      <div v-for="(message, index) in conversationMessages" :key="index">
                        <div
                          class="col-9 bg-light black-text p-2 mb-3"
                          v-if="conversation.receiver._id == message.sender"
                        >
                          <div>
                            <small class="font-weight-bold">
                              {{ message.date | moment("dddd, MMMM Do YYYY") }} :
                            </small>
                          </div>
                          {{ message.message }}
                        </div>

                        <div
                          v-if="message.sender == fastTeacherId"
                          class="col-9 bg-dark white-text p-2 offset-3 mb-3"
                        >
                          <div>
                            <small class="font-weight-bold">
                              {{ message.date | moment("dddd, MMMM Do YYYY") }} :
                            </small>
                          </div>
                          {{ message.message }}
                        </div>
                      </div>

                      <div class="shadow border z-depth-3 p-3">
                        <input
                          v-model="messageToSend"
                          required
                          type="text"
                          class="form-control"
                          placeholder="Start typing here..., hit enter to send"
                        />
                      </div>
                    </div>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-danger btn-sm"
                        data-dismiss="modal"
                        @click="modalChat = false"
                      >
                        Close chat
                      </button>
                    </div>
                  </mdb-modal-body>
                </mdb-modal>
              </mdb-container>
              <button hidden type="submit">Send</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mdbContainer, mdbModal, mdbModalBody } from "mdbvue";

export default {
  name: "TeacherClass",
  components: {
    mdbContainer,
    mdbModal,
    mdbModalBody,
  },
  data() {
    return {
      fastTeacherToken: localStorage.getItem("fastTeacherToken"),
      fastTeacherId: localStorage.getItem("fastTeacherId"),
      conversations: [],
      conversationMessages: [],
      loading: false,
      modalChat: false,
      messageToSend: "",
      receiverId: "",
      conversationId: "",
    };
  },
  sockets: {
    connect: function () {
      // eslint-disable-next-line no-console
      console.log("socket connected");
    },

    disconnect: function () {
      // eslint-disable-next-line no-console
      console.log("socket disconnected");
    },

    new_message: function (message) {
      // eslint-disable-next-line no-console
      console.log(message.message);
    },

    f_error: function (error) {
      this.$toast.open({
        message: "Error :" + error,
        type: "error",
      });
    },
    error: function (error) {
      this.$toast.open({
        message: "Error :" + error,
        type: "error",
      });
    },
  },

  methods: {
    sendMessage(receiver, message) {
      // $socket is socket.io-client instance
      this.$socket.emit("new_message", { receiver, message });
    },

    sendNewMessage: function (e) {
      let message = this.messageToSend;
      this.sendMessage(this.receiverId, message);
      this.$toast.open({
        message: "<i class='fas fa-check'></i>",
        type: "success",
      });
      this.refreshChat();
      this.messageToSend = "";
      this.getMessages(this.conversationId);
      e.target.reset();
    },

    refreshChat() {
      const config = {
        headers: {
          Authorization: "Bearer " + this.fastTeacherToken,
          "Content-Type": "application/json",
        },
      };

      axios
        .get(this.$apiURI + "/conversations", config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            this.conversations = response.data.data.conversations;
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(error);
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        });
    },

    getMessages(conversationId) {
      const config = {
        headers: {
          Authorization: "Bearer " + this.fastTeacherToken,
          "Content-Type": "application/json",
        },
      };

      axios
        .get(this.$apiURI + "/conversations/" + conversationId + "/messages", config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            this.conversationMessages = response.data.data.messages;
            this.conversationMessages = this.conversationMessages.reverse();
            this.modalChat = true;
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(error);
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        });
    },
  },

  mounted() {
    const config = {
      headers: {
        Authorization: "Bearer " + this.fastTeacherToken,
        "Content-Type": "application/json",
      },
    };

    axios
      .get(this.$apiURI + "/conversations", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          this.conversations = response.data.data.conversations;
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error);
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });
  },
};
</script>
